module.exports = __webpack_public_path__ + "img/ics_o_box_alt.1ac97829.svg";